import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IRoutingFilterResult } from './RoutingFilterTypes';

export interface ICreateRoutingFilterData {
  domain: string;
  isBlocked: boolean;
  poolId?: string | null;
  projects?: { ids: string[] };
}

export interface ICreateRoutingFilterParams {
  siteId: string;
  routingRule: ICreateRoutingFilterData;
}

export class CreateRoutingFilterRequest extends Request<ICreateRoutingFilterParams, IRoutingFilterResult> {
  constructor(params: ICreateRoutingFilterParams) {
    super('createRoutingRule', params);
  }
}
